
const rts = {
  handleResponse_survey: 'handleResponse_survey',
}

export const _collectionName = '_survey'

export const surverReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleResponse_survey:
      const activeSurvey = action.survey && action.survey.activeSurvey ? action.survey.activeSurvey : {}
      return { ...state, activeSurvey: activeSurvey }


    default:
      return { ...state }
  }
}

export const surveyInitialState = (initState) => {
  return { ...initState }
};

export const surveyHandlers = (dispatch) => {
  return {
    handleResponse_survey: (survey) => { dispatch({ type: rts.handleResponse_survey, dispatch, survey }) },
  }
} 